// utils
import { makeApiCall } from "@payment-client/utils/Api";

// interfaces
import * as CheckoutApi from "@payment-client/interfaces/Checkout";
import { ApiResponse } from "@payment-client/interfaces/Api";

// constants
import { API_SUCCESS_STATUS_CODE } from "@payment-client/constants/StatusCodes";

const ENDPOINT = {
    REGISTER_PAY_ON_DELIVERY: "/api/v1/order/register_pay_on_delivery",
};

export async function generateCartKeyForPayOnDelivery(
    apiHost: string,
    params: { orderId: string },
): Promise<ApiResponse<CheckoutApi.RequestCartKeyForPayOnDeliveryPayload>> {
    const response = await makeApiCall<CheckoutApi.RequestCartKeyForPayOnDeliveryPayload>({
        apiHost,
        endpoint: ENDPOINT.REGISTER_PAY_ON_DELIVERY,
        bodyParams: params,
        options: {
            method: "POST",
        },
    });

    if (response.statusCode !== API_SUCCESS_STATUS_CODE) {
        throw response;
    } else {
        return response;
    }
}
